import { gql } from "@apollo/client";

export const QUOTE = gql`
  fragment Quote on QuoteRecord {
    id
    text {
      value
    }
    author
    authorImage {
      responsiveImage(
        imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "72", h: "72", q: "75" }
      ) {
        alt
        height
        src
        title
        width
      }
    }
    authorFunction
  }
`;
